import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-11/12 md:w-10/12 overflow-x-hidden flex flex-col justify-center mx-auto items-center text-parentText" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Nav = _resolveComponent("Nav")
  const _component_Landing = _resolveComponent("Landing")
  const _component_Reads = _resolveComponent("Reads")
  const _component_GetInformed = _resolveComponent("GetInformed")
  const _component_Review = _resolveComponent("Review")
  const _component_Overview = _resolveComponent("Overview")
  const _component_Prelim = _resolveComponent("Prelim")
  const _component_Footer = _resolveComponent("Footer")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Nav),
    _createElementVNode("div", null, [
      _createVNode(_component_Landing)
    ]),
    _createVNode(_component_Reads),
    _createVNode(_component_GetInformed),
    _createVNode(_component_Review),
    _createVNode(_component_Overview),
    _createVNode(_component_Prelim),
    _createVNode(_component_Footer)
  ]))
}